// A page-wide "a live call is connected right now" flag, set by
// useCallAudio()'s connect/teardown (manual calls and supervisor
// listen/takeover both go through it). Anything that would otherwise
// disrupt the page unconditionally — most importantly the PWA's
// auto-reload-on-new-version in index.js — should check this first and
// defer until the call actually ends, instead of yanking the page out from
// under someone mid-call.
let activeCalls = 0;
const idleListeners = new Set<() => void>();

export function markCallActive(): void {
  activeCalls += 1;
}

export function markCallInactive(): void {
  activeCalls = Math.max(0, activeCalls - 1);
  if (activeCalls === 0) {
    idleListeners.forEach((fn) => fn());
  }
}

export function isCallActive(): boolean {
  return activeCalls > 0;
}

/** Fires once, the next time no calls are active (immediately if already idle). */
export function runWhenIdle(fn: () => void): void {
  if (!isCallActive()) {
    fn();
    return;
  }
  const listener = () => {
    idleListeners.delete(listener);
    fn();
  };
  idleListeners.add(listener);
}
